import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import { Form, Formik } from "formik";
import { FormGroup } from "reactstrap";
import { useState } from "react";
import FormikTextField from "../../../Common/FormFields/FormikInputField";
import FormikDropDown from "../../../Common/FormFields/FormikDropDown";
import RadioButton from "../../../Common/FormFields/RadioButton";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import GameSchedule from "../Seasons/GameSchedule";
import { useRef } from "react";
import validationSchema from "../../../Validation/ValidationSchemas";
import { useEffect } from "react";
import {
  setEditSchedule,
  setFormHook,
} from "../../../Redux/Actions/LoginActions";
import userService from "../../../services/user.service";
import {
  openFailDialog,
  openSuccessPopup,
} from "../../../Redux/Actions/PopupActions";
import { getFromLocalStorage } from "../../../utils/webStorage";
import { permissionNames } from "../../../utils/constant";
const AddEditSchedule = ({
  successPopUp,
  toggleSuccessDialog,
  fetchSchedulesByPage,
  pageState,
  fetchSeasonWeeks,
  searchSchedule,
  searchedRecord,
  searchQuery,
}) => {
  const [eventTime, setEventTime] = useState(new Date());
  const userId = getFromLocalStorage("userId");
  const myref = useRef();
  const dispatch = useDispatch();
  const currentSeason = useSelector(
    (state) => state?.loggedInUser?.currentSeason
  );
  const schoolId = useSelector((state) => state?.loggedInUser?.school?.id);
  const isEditSchedule = useSelector(
    (state) => state?.loggedInUser?.isEditSchedule
  );
  const scheduleInformation = useSelector(
    (state) => state?.loggedInUser?.scheduleInformation
  );
  const [assignedRights, setAssignedRights] = useState([]);
  const loginRole = getFromLocalStorage("loginRole");

  useEffect(() => {
    const assignedRights = JSON.parse(
      getFromLocalStorage("assignedRights") || []
    );
    const assignedRightsIds = assignedRights.map((item) => item.displayName);
    setAssignedRights(assignedRightsIds);
    setFormHook(dispatch, myref);
  }, []);

  const handleRadioClick = (e, setField) => {
    if (e.target.value === "off-season") {
      myref.current.setFieldValue("week", "");
      myref.current.setFieldValue("eventType", "");
      myref.current.setFieldValue("location", "");
      myref.current.setFieldValue("opponent", "");
    }
    myref.current.setFieldValue(setField, e.target.value);
  };

  const isRadioSelected = (value, stateToCompare) => {
    return value === stateToCompare;
  };

  const setTime = (time) => {
    setEventTime(time);
    let result = time.toString().substring(16, 21);
    myref.current.setFieldValue("eventTime", time);
    myref.current.setFieldError("eventTime", "");
  };

  const handleSubmit = ({
    event,
    week,
    eventType,
    location,
    opponent,
    eventDate,
    eventTime,
  }) => {
    if (
      loginRole === "SCHOOL ADMIN" ||
      assignedRights?.includes("Add/ Remove Schedule")
    ) {
      isEditSchedule
        ? editSchedule(
            event,
            eventType,
            location,
            eventDate,
            eventTime,
            schoolId,
            opponent,
            currentSeason.id,
            week
          )
        : createSchedule(
            event,
            eventType,
            location,
            eventDate,
            eventTime,
            schoolId,
            opponent,
            currentSeason.id,
            week
          );
    } else {
      openFailDialog(dispatch, {
        open: true,
        message: "You Don't Have Permission To Add / Remove Schedules",
      });
    }
  };

  const createSchedule = (
    event,
    eventType,
    location,
    eventDate,
    eventTime,
    schoolId,
    opponent,
    seasonId,
    weekId
  ) => {
    userService
      .createSchedule(
        event,
        eventType,
        location,
        moment(eventDate).format("YYYY-MM-DD HH:mm:ss"),
        getEventtime(eventDate, eventTime),
        schoolId,
        opponent,
        seasonId,
        weekId
      )
      .then((res) => {
        userService.addActivitySeasonOrScheduleAdded(
          res.data.data.id,
          null,
          schoolId,
          userId,
          "CELL",
          "SCHEDULE_ADDED"
        );
        fetchSeasonWeeks();
        setEditSchedule(dispatch, false);
        searchedRecord
          ? searchSchedule(searchQuery, pageState.page, pageState.pageSize)
          : fetchSchedulesByPage(pageState.page, pageState.pageSize);
        toggleSuccessDialog(dispatch, false);
        openSuccessPopup(dispatch, {
          successPopUp: {
            message: "Game Scheduled Successfully",
            open: true,
          },
        });
      })
      .catch((err) => {
        openFailDialog(dispatch, {
          open: true,
          message: "Something Went Wrong.",
        });
      });
  };

  const editSchedule = (
    event,
    eventType,
    location,
    eventDate,
    eventTime,
    schoolId,
    opponent,
    seasonId,
    weekId
  ) => {
    userService
      .editSchedule(
        scheduleInformation.id,
        event,
        eventType,
        location,
        moment(eventDate).format("YYYY-MM-DD HH:mm:ss"),
        getEventtime(eventDate, eventTime),
        schoolId,
        opponent,
        seasonId,
        weekId
      )
      .then((res) => {
        fetchSeasonWeeks();
        setEditSchedule(dispatch, false);
        searchedRecord
          ? searchSchedule(searchQuery, pageState.page, pageState.pageSize)
          : fetchSchedulesByPage(pageState.page, pageState.pageSize);
        toggleSuccessDialog(dispatch, false);
        openSuccessPopup(dispatch, {
          successPopUp: {
            message: "Game Updated Successfully",
            open: true,
          },
        });
      })
      .catch((err) => {
        openFailDialog(dispatch, {
          open: true,
          message: "Something Went Wrong.",
        });
      });
  };

  const getEventtime = (date, time) => {
    const eventDate = moment(date).format("YYYY-MM-DD");
    const eventTime = moment(time).format("HH:mm:ss");
    const convertedTime = `${eventDate} ${time}:00`;
    return convertedTime;
  };

  const defaultDate = () => {
    const minYear = currentSeason?.years?.substring(0, 4);
    let eventDate = new Date();
    if (Number(minYear) > new Date().getFullYear()) {
      eventDate = new Date(minYear, 0, 1);
    }
    return eventDate;
  };

  return (
    <>
      <Dialog
        id="dialogBoxRemove"
        className="dialog-stylee"
        open={successPopUp}
        onClose={() => {
          setEditSchedule(dispatch, false);
          toggleSuccessDialog(dispatch, false);
        }}
      >
        <DialogContent>
          <div className="clear10"></div>
          <div className="row">
            <Formik
              validationSchema={validationSchema.buildScheduleSchema}
              initialValues={{
                season: currentSeason?.years,
                event: isEditSchedule ? scheduleInformation.seasonType : "",
                week: isEditSchedule
                  ? scheduleInformation.seasonWeek.id
                  : pageState.data.length === 0
                  ? 1
                  : "",
                eventType: isEditSchedule ? scheduleInformation.eventType : "",
                location: isEditSchedule ? scheduleInformation.location : "",
                opponent: isEditSchedule
                  ? scheduleInformation.opponent.schoolName
                  : "",
                eventDate: isEditSchedule
                  ? new Date(scheduleInformation.eventDate)
                  : defaultDate(),
                eventTime: isEditSchedule
                  ? scheduleInformation.eventTime.substring(0, 5)
                  : "19:30",
                offSeasonDate: new Date(),
                otherTeams: [],
              }}
              innerRef={myref}
              onSubmit={(values) => handleSubmit(values)}
            >
              {(formik) => (
                <Form>
                  <FormikTextField
                    label="Season"
                    formik={formik}
                    fieldName="season"
                    isDisabled={true}
                  />
                  <FormGroup>
                    <label className="fmlabel mt-6 semi-bold">
                      Select Event <span className="redstar">*</span>
                    </label>
                    <div className="d-flex flex-direction-r gap-20">
                      <RadioButton
                        label="In-Season"
                        value="in-season"
                        isRadioSelected={isRadioSelected}
                        stateToCompare={formik.values.event}
                        setState="event"
                        fieldName="event"
                        handleRadioClick={handleRadioClick}
                      />
                    </div>

                    <div className="errorMsg fs-14 medium">
                      {formik.touched.event && formik.errors.event}
                    </div>
                  </FormGroup>

                  {formik.values.event &&
                    formik.values.event === "in-season" && (
                      <GameSchedule
                        formik={formik}
                        myref={myref}
                        isRadioSelected={isRadioSelected}
                        handleRadioClick={handleRadioClick}
                        setTime={setTime}
                        eventTime={eventTime}
                        pageState={pageState}
                      />
                    )}

                  <div className="col-12 col-md-12 col-lg-12 ml-auto text-center mg-top-20">
                    <button
                      type="button"
                      className="rectangle-btn bg-grey white mr-2"
                      onClick={() => {
                        setEditSchedule(dispatch, false);
                        toggleSuccessDialog(dispatch, false);
                      }}
                    >
                      Cancel
                    </button>

                    <button
                      type="submit"
                      className={
                        formik.isValid
                          ? "rectangle-btn bg-navyBlue white"
                          : "rectangle-btn bg-navyBlue white inactive"
                      }
                      disabled={!formik.isValid}
                    >
                      Save
                    </button>
                  </div>
                </Form>
              )}
            </Formik>
          </div>

          <div className="clear10"></div>

          <div className="clear10"></div>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default AddEditSchedule;
